//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      options: {},
    };
  },
  mounted() {
    this.options = {
      color: [
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#FFC793",
            },
            {
              offset: 1,
              color: "#FFFFFF",
            },
          ],
          global: false,
        },
        {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#DA302A",
            },
            {
              offset: 1,
              color: "#FFFFFF",
            },
          ],
          global: false,
        },
      ],
      grid: {
        top: 58,
        left: 0,
        right: 0,
        bottom: 20,
      },
      tooltip: {
        show: true,
        trigger: "axis",
        formatter: "{b}月<br />{a0}：{c0}<br />{a1}：{c1}",
      },
      legend: {
        right: 10,
        orient: "vertical",
        icon: "rect",
        itemWidth: 19,
        itemHeight: 7,
        textStyle: {
          color: "#666666",
          fontWeight: "bold",
        },
      },
      xAxis: {
        type: "category",
        data: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
        boundaryGap: [1, 1],
        axisLine: {
          lineStyle: {
            color: "rgb(132, 77, 26, 0.5)",
          },
        },
        axisTick: {
          alignWithLabel: true,
          lineStyle: {
            color: "#844D1A",
          },
        },
        axisLabel: {
          interval: 0,
          color: "#333333",
        },
      },
      yAxis: {
        type: "value",
        axisLine: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: "rgb(132, 77, 26, 0.1)",
          },
        },
      },
      series: [
        {
          name: "同比",
          type: "bar",
          data: [20, 30, 50, 94, 78, 70, 40, 70, 84, 34, 86, 105],
          barGap: "10%",
          barCategoryGap: "30%",
        },
        {
          name: "客流",
          type: "bar",
          data: [70, 40, 70, 84, 34, 20, 30, 50, 94, 78, 106, 45],
        },
      ],
    };
  },
};
